import { gql } from '@apollo/client';
import { MediaQueries } from '@minecraft.shared-queries';

export const ProfileMediaFragment = gql`
  fragment ProfileMediaValues on ProfileMedia {
    __typename
    created
    isPrimary
    order
    id
    profileMediaId
    media {
      ...BaseMediaWithThumbnail
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;

export const EDIT_PHOTO = gql`
  mutation EDIT_PHOTO($input: MediaTransformationInput!, $id: Int!) {
    editMedia(input: $input, id: $id) {
      ...BaseMediaWithThumbnail
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;

export const EDIT_THUMBNAIL = gql`
  mutation EDIT_THUMBNAIL($input: MediaTransformationInput!, $id: Int!) {
    editMediaThumbnail(input: $input, id: $id) {
      ...BaseMediaWithThumbnail
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;

export const GET_UPLOADED_PHOTO_DATA = gql`
  {
    uploadedPhotoData @client {
      uploadedPhotoList {
        ...BaseMediaWithThumbnail
      }
      forwardedPage
      successfullySaved
      isPrimary
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;

export const UPDATE_UPLOADED_PHOTO_DATA = gql`
  mutation UPDATE_UPLOADED_PHOTO_DATA(
    $uploadedPhotoList: [Media]!
    $forwardedPage: String!
    $successfullySaved: Boolean
    $isPrimary: Boolean
  ) {
    updateUploadedPhotoData(
      uploadedPhotoList: $uploadedPhotoList
      forwardedPage: $forwardedPage
      successfullySaved: $successfullySaved
      isPrimary: $isPrimary
    ) @client
  }
`;
